<template>
  <basic-master
    masterName="タグ"
    insertDataPageName="addon-port-master-tag-insert"
    @callDelete="callDelete"
    @callSave="callSave"
    @callUpdateOrder="callUpdateOrder"
    :data="data"
    :sortable="false"
    :columns="columns"
    :colorOptions="colorOptions"
    ref="basicMaster"
  >
  </basic-master>
</template>

<script>

import BasicMaster from "../components/BasicMaster";
import { createNamespacedHelpers } from "vuex";
import { snakeCase } from "snake-case";
const { mapActions, mapState } = createNamespacedHelpers("portMaster");
export default {
  components: {
    BasicMaster
  },
  data() {
    return {
      columns: [
        {
          displayName:"名称",
          inputType: "string",
          key: "name",
          searchable: true,
        },
        {
          displayName:"カラーコード",
          inputType: "color",
          key: "color",
          searchable: false,
        },
        {
          displayName:"備考",
          inputType: "textArea",
          key: "description",
          searchable: false,
        },
      ],
      data: [],
    }
  },
  async created() {
    this.$vs.loading()
    this.refreshData()
    await this.fetchColors(this.selectedPort.id)
    this.$vs.loading.close()
  },
  computed: {
    ...mapState({
      selectedPort: state => state.selectedPort,
      colorOptions: state => state.colorOptions,
    }),
  },
  methods: {
    ...mapActions(["fetchTags", "updateTag", "deleteTag", "updateTagOrders", "fetchColors"]),
    async refreshData() {
      let res = await this.fetchTags(this.selectedPort.id)
      this.data = res.tags
    },
    async callSave(editedRowData) {
      let payload = {
        portId: this.selectedPort.id,
        id: editedRowData.id,
        body: {
          color_id: editedRowData.color.id,
          name: editedRowData.name,
          version: editedRowData.version,
          description: editedRowData.description,
        }
      }
      this.$vs.loading()
      try {
        await this.updateTag(payload)
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
      } catch(error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map(element => {
            let targetKey = snakeCase(element.target)
            let index = this.columns.findIndex(column => column.key == targetKey)
            let label = this.columns[index].displayName
            let message = element.message
            return {
              label: label,
              message: message
            }
          })
          this.$refs.basicMaster.openErrorPopup("エラー", null, validationErrors)
        } else {
          this.$refs.basicMaster.openErrorPopup("エラー", error.message, null)
        }
      }
      this.refreshData()
      this.$vs.loading.close()
    },
    async callDelete(id) {
      let payload = {
        portId: this.selectedPort.id,
        id: id,
      }
      this.$vs.loading()
      await this.deleteTag(payload)
      this.refreshData()
      this.$vs.loading.close()

      this.$vs.notify({
        title: "データを削除しました。",
        color: "danger",
        iconPack: "feather",
        icon: "icon-check",
        position: "top-center"
      })
    },
    async callUpdateOrder(sortOrders) {
      let payload = {
        portId: this.selectedPort.id,
        body: {
          sort_orders: sortOrders
        }
      }
      this.$vs.loading()
      await this.updateTagOrders(payload)
      this.refreshData()
      this.$vs.loading.close()
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
